import React from "react";
import { useTranslation } from "react-i18next";
import BusinessCard from "../../utility/BusinessCard";
import { Container } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BusinessSection = () => {
  const { t } = useTranslation('homepage');

  const cardData = [
    {
      title: t('business-section-card-title1'),
      backgroundColor: "linear-gradient(138.62deg, #E5DBEF 0.09%, #FFFFFF 69.08%)",
      image: `/images/homepage-card-img-1.png`,
    },
    {
      title: t('business-section-card-title2'),
      backgroundColor: "linear-gradient(140.06deg, #F4E7D4 1.2%, #FFFFFF 78.92%)",
      image: `/images/homepage-card-img-2.png`,
    },
    {
      title: t('business-section-card-title3'),
      backgroundColor: "linear-gradient(138.76deg, #D0D9F0 1.91%, #FFFFFF 79.24%)",
      image: `/images/homepage-card-img-3.png`,
    },
    {
      title: t('business-section-card-title4'),
      backgroundColor: "linear-gradient(138.62deg, rgba(252, 196, 157, 0.62) 0.09%, #FFFFFF 69.08%)",
      image: `/images/homepage-card-img-4.png`,
    },
  ];

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };

  return (
    <section className="py-5 text-center">
      <Container>
        <h2 className="fw-bold mb-3">{t('business-section-heading')}</h2>
        <p className="text-secondary mb-5">
          {t('business-section-description')}
        </p>
        <Slider {...sliderSettings}>
          {cardData.map((card, index) => (
            <div key={index} className="px-2 px-sm-3">
              <BusinessCard {...card} />
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default BusinessSection;